export const environment = {
  production: true,
  hostTLD: 'actionbuilder.org',
  enableSentry: true,
  // Due to how AngularTokenAuth determines how to attach headers
  // we must use the current origin as the api base.  This
  // fixes issues with tokens being either attached to CORS requests
  // or excluded from graphQL requests on login.
  get apiBase() {
    return window.location.origin;
  },
  mapbox_access_key: 'pk.eyJ1IjoiYWN0aW9ubmV0d29yayIsImEiOiJjamswYWo2NG4wNHNsM3ZydGE0Zml5NTZiIn0.Pl6L1gV87_yRUslXnFGC3g',
  graph_hopper_api_key: '6e71949c-74b9-4bbd-a32a-a180512b3532'
};
